import { render } from "./SettlementAccount.m.backup.vue?vue&type=template&id=2b4d5a58&scoped=true"
import script from "./SettlementAccount.m.backup.vue?vue&type=script&lang=js"
export * from "./SettlementAccount.m.backup.vue?vue&type=script&lang=js"

import "./SettlementAccount.m.backup.vue?vue&type=style&index=0&id=2b4d5a58&scoped=true&lang=css"

import exportComponent from "/Users/sung-hojang/git-projects/jpworldpay-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4d5a58"]])

export default __exports__